import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { useDeleteDocumentTypeMutation } from '../../../store/ai/documentTypes'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'

import { DocumentType } from '../../../models/DocumentType'

import { Modal } from '../../../components/Modal/Modal'

export interface UninstallDocumentTypeModalProps {
  show: boolean
  onHide: () => void
  documentType: DocumentType
}

export const UninstallDocumentTypeModal: React.FC<UninstallDocumentTypeModalProps> = ({ show, onHide, documentType }) => {
  const accountId = useAppSelector(selectAccountId)

  const [triggerDeleteDocumentType, { isSuccess, isLoading }] = useDeleteDocumentTypeMutation()

  const handleDeleteDocumentType = async () => {
    await triggerDeleteDocumentType({ accountId, documentTypeId: documentType.id })
  }

  useEffect(() => {
    if (isSuccess) {
      onHide()
    }
  }, [isSuccess, onHide])

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Document Type</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete document type <b>{documentType.name}</b> ?
          </div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteDocumentType}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
